import { Button } from '@repo/go-ui';
import { useTranslation } from 'react-i18next';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { RefreshKeyCloakUsersAndGroups } from './refresh-keycloak-users-and-groups';

const RefreshKeyCloakUsersAndGroupsButton = wrap<{ pluginController: RefreshKeyCloakUsersAndGroups }>(
  function RefreshKeyCloakUsersAndGroupsButton({ pluginController }) {
    const { t } = useTranslation();

    return (
      <Button
        onClick={pluginController.refreshKeyCloak}
        disabled={pluginController.directoryPageService.isEditing}
        loading={pluginController.isLoading}
        style={{ textWrap: 'nowrap' }}
      >
        {t('plugins:RefreshKeyCloakUsersAndGroups.button')}
      </Button>
    );
  },
);

export function renderRefreshKeyCloakUsersAndGroupsButton(pluginController: RefreshKeyCloakUsersAndGroups) {
  return <RefreshKeyCloakUsersAndGroupsButton pluginController={pluginController} />;
}
